export const buildRegionRangeName = range => `${range.start}-${range.end}`;

export default { buildRegionRangeName };
